import { forwardRef } from 'react';

const VARIANT_CLASSES = {
  primary:
    'bg-accent text-white hover:bg-accent-hover focus-visible:ring-accent border border-transparent',
  secondary:
    'bg-bg text-text border border-border hover:border-accent hover:text-accent focus-visible:ring-accent',
  ghost:
    'bg-transparent text-text-muted hover:text-accent border border-transparent focus-visible:ring-accent',
  danger: 'bg-error text-white hover:opacity-90 focus-visible:ring-error border border-transparent',
};

const SIZE_CLASSES = {
  sm: 'px-3 py-1 text-sm',
  md: 'px-4 py-2 text-base',
};

const Button = forwardRef(function Button(
  { variant = 'primary', size = 'md', type = 'button', className = '', disabled, ...rest },
  ref,
) {
  const classes = [
    'inline-flex items-center justify-center rounded-md font-body font-medium transition-colors',
    'focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-offset-bg',
    'disabled:cursor-not-allowed disabled:opacity-50',
    VARIANT_CLASSES[variant] ?? VARIANT_CLASSES.primary,
    SIZE_CLASSES[size] ?? SIZE_CLASSES.md,
    className,
  ].join(' ');

  return <button ref={ref} type={type} className={classes} disabled={disabled} {...rest} />;
});

export default Button;
